import type { Dispatch, SetStateAction } from 'react'
import CheckSaveIcon from 'src/images/icons/CheckSaveIcon'

import {
  isCompletePostalCode,
  maskPostalCodeTyping,
} from '../../utils/postalCode'

interface PostalCodeInputFormProps {
  inputValue: string
  setInputValue: Dispatch<SetStateAction<string>>
  onSubmit: (
    value: string,
    options?: { shouldTrackConfirmation?: boolean }
  ) => Promise<void>
  setIsEditingAddress?: Dispatch<SetStateAction<boolean>>
  showLabel?: boolean
  hasAddress?: boolean
}

export function PostalCodeInputForm({
  inputValue,
  setInputValue,
  onSubmit,
  setIsEditingAddress,
  showLabel = false,
  hasAddress = false,
}: PostalCodeInputFormProps) {
  const isInputValid = isCompletePostalCode(inputValue)

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = maskPostalCodeTyping(e.target.value)

    setInputValue(value)

    if (showLabel && isCompletePostalCode(value)) {
      onSubmit(value, { shouldTrackConfirmation: false }).finally(() => {
        if (!setIsEditingAddress) return
        setIsEditingAddress(true)
      })
    }
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (!isInputValid) return

    onSubmit(inputValue, { shouldTrackConfirmation: true }).finally(() => {
      if (!setIsEditingAddress) return

      setIsEditingAddress(true)
    })
  }

  return (
    <form
      className={`flex flex-col sm:flex-row gap-2.5 w-full ${
        showLabel ? 'mb-2' : ''
      }`}
      onSubmit={handleSubmit}
    >
      <div
        className={`flex flex-col gap-2 ${
          showLabel ? '' : 'items-center w-full'
        }`}
      >
        {showLabel && (
          <label
            htmlFor="postal-code-input"
            className="text-font-size-2 text-restructure-primary font-semibold"
          >
            CEP <span className="text-[#D62828]">*</span>
          </label>
        )}
        <input
          id="postal-code-input"
          name="postalCode"
          data-testid="postal-code-input"
          className={`w-full border checkout-profile-input border-neutral01 text-body-md text-restructure-primary py-5 px-4  rounded-none hover:rounded-none hover:outline-none hover:border-2 hover:border-primaryBlue focus:rounded-none focus:outline-none focus:border-2 focus:border-primaryBlue disabled:bg-postal-input-disabled disabled:text-[#000] disabled:hover:border-neutral01 ${
            showLabel ? 'h-11' : 'h-12'
          }`}
          placeholder="00000-000"
          type="text"
          value={inputValue}
          onChange={handleInputChange}
          maxLength={9}
        />
      </div>
      {!showLabel && (
        <button
          type="submit"
          disabled={!isInputValid}
          className={`h-12 px-5 bg-postal-accent text-restructure-primary-inverted text-[15px] font-bold ${
            isInputValid ? '' : 'opacity-40'
          } `}
        >
          Usar
        </button>
      )}
      {hasAddress && (
        <span className="flex gap-1 items-center text-[13px] leading-normal text-[#2BA84A] mt-1.5">
          <CheckSaveIcon color="#2BA84A" />
          Endereço encontrado. Revise os dados abaixo.
        </span>
      )}
    </form>
  )
}
